import { render, staticRenderFns } from "./EditSeriacionMateria.vue?vue&type=template&id=003fb0ca&scoped=true&"
import script from "./EditSeriacionMateria.vue?vue&type=script&lang=js&"
export * from "./EditSeriacionMateria.vue?vue&type=script&lang=js&"
import style0 from "./EditSeriacionMateria.vue?vue&type=style&index=0&id=003fb0ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003fb0ca",
  null
  
)

export default component.exports